import React, { createContext, useContext, useReducer } from "react";

const CartStateContext = createContext();
const CartDispatchContext = createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD":
      return [...state, { id: action.id, name: action.name, price: action.price, img: action.img, quantity: action.quantity, size: action.size }]

    case "REMOVE":
      let newArray = [...state];
      newArray.splice(action.index, 1)
      return newArray;

    case "DROP":
      return [];

    case "UPDATE":
      let array = [...state]
      array.find((food, index) => {
        if (food.id === action.id) {
          array[index] = { ...food, quantity: parseInt(action.quantity) + parseInt(food.quantity), price: action.price + food.price }
        }
        return array
      })
      return array

    default:
      console.log("Error in Reducer");
  }
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, []);
  return (
    <CartDispatchContext.Provider value={dispatch}>
      <CartStateContext.Provider value={state}>{children}</CartStateContext.Provider>
    </CartDispatchContext.Provider>
  );
};


export const useCart = () => {
  return useContext(CartStateContext)
}

export const useCartDispatch = () => {
  return useContext(CartDispatchContext)
}